export default __webpack_public_path__ + "static/media/final.8d90741f.mp4";